import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../../shared/ui/Inputs';
import { WideLayout } from '../../../shared/layout/widelayout';
import { useLayoutStore } from '../../../stores/portalStore';
import { usePatientsStore } from '../../patients/store/patientsStore';
import { useTechnicalAssistanceStore } from '../store/technicalAssistanceStore';
import { PatientsList } from '../../patients/usecases/legacy/list';
import { useResponsive } from '../../../hooks/useResponsive';

const MainPanels = () => {
  const setSelectedPatient = useTechnicalAssistanceStore(
    (state) => state.setSelectedPatient
  );
  const selectedPatient = useTechnicalAssistanceStore(
    (state) => state.selectedPatient
  );
  const reset = useTechnicalAssistanceStore((state) => state.reset);
  const patients = usePatientsStore((state) => state.patients);
  const header = ['Nome', 'CPF', 'Empresa', 'CNPJ', 'Endereço'];
  const fields = ['name', 'cpf', 'company', 'cnpj', 'address'];
  const navigate = useNavigate();
  const contentWidth = useLayoutStore((state) => state.contentWidth);
  const { isDesktop } = useResponsive();
  const containerWidth = isDesktop && contentWidth ? contentWidth : '100%';

  useEffect(() => {
    reset();
  }, []);

  const onRowSelected = (_row, rowIndex) => {
    setSelectedPatient(patients[rowIndex]);
  };

  const continueToCategory = () => {
    if (selectedPatient !== null) {
      navigate('/technicalAssistance/assistance');
    }
  };

  return (
    <div
      style={{
        maxWidth: containerWidth,
        margin: '15px',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '16px',
      }}
    >
      <PatientsList
        title={'Assistência técnica'}
        topSearchRight={true}
        onlyActives={false}
        newClientAction={
          <PrimaryButton
            disabled={selectedPatient === null}
            onClick={continueToCategory}
          >
            Prosseguir
          </PrimaryButton>
        }
        height={window.innerHeight - 400 + 'px'}
        subtitle={''}
        readOnly={true}
        header={header}
        fields={fields}
        onRowSelected={onRowSelected}
        disableSearchWhileLoading={true}
        resetSearchOnMount={true}
        useOrderFlowTable={true}
        manualSearch={true}
      />
    </div>
  );
};

export const TechnicalAssistanceSelectPatientsPage = () => {
  return <WideLayout outlet={<MainPanels />} />;
};
